<template>
  <SpaceSettingsEditModalTemplate @close="$emit('close')">
    <template v-slot:title>{{ $t('editTitle') }}</template>
    <template v-slot:form>
      <ExpenseSettingsForm :edit_item="edit_expense"
                           @cancelEdit="$emit('close')"/>
    </template>
  </SpaceSettingsEditModalTemplate>
</template>

<script>
import CustomModal from "@/components/UI/modals/CustomModal";
import IncomeSettingsForm from "@/components/cabinet/SpaceSettings/IncomeSettings/IncomeSettingsForm";
import SpaceSettingsEditModalTemplate from "@/components/UI/SpaceSettings/SpaceSettingsEditModalTemplate";
import ExpenseSettingsForm from "@/components/cabinet/SpaceSettings/ExpenseSettings/ExpenseSettingsForm";

export default {
  name: "ExpenseSettingsEditModal",
  props: {
    edit_expense: {
      type: Object
    }
  },
  components: {ExpenseSettingsForm, SpaceSettingsEditModalTemplate, IncomeSettingsForm, CustomModal},
  i18n: {
    messages: {
      en: {
        editTitle: 'Edit expense category'
      },
      ru: {
        editTitle: 'Редактирование категории расхода'
      }
    }
  }
}
</script>